import React, {useState} from 'react';
import SearchMedicines from '../components/searchMedicines';
import { Tag, Button, Popconfirm, message  } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useFirestore } from 'reactfire';

const SingleFavAdd = (props) => {

    const firestore = useFirestore();
    const [tags, setTags] = useState(props.currentFav.value.Treatment_list || []); 
    const query_fav = firestore.collection('Favourite_Treatment');

    const onSelect = (data) => {
        console.log(data);
        setTags([...tags, data]);
    }

    const handleClose = removedTag => {
        const newTags = tags.filter(tag => tag !== removedTag);
        setTags(newTags);
    };

    const addTreatmentToLIst = id => {
        query_fav.doc(id).update({Treatment_list : tags}).then((response) => {
            message.success('List Saved');
            props.listUpdated();
        });
    }


    const confirm = (e) => {
        props.onFavListDelete(props.currentFav.id);
    }


    return (
        <li key={props.currentFav.id}>
            {/* <Skeleton active /> */}
            <Popconfirm
                title="Are you sure to delete this Favorite List?"
                onConfirm={confirm}
                okText="Yes"
                cancelText="No"
            >
                <span className='deleteFavList'><DeleteOutlined /></span>
            </Popconfirm>
            <h3>{props.currentFav.value.favourite_list_name}</h3>
            <Button type="primary" className='savFavList' onClick={() => addTreatmentToLIst(props.currentFav.id)}>Save</Button>
        </li>
    );
}

export default SingleFavAdd;
